import { useFilters } from './useFilters';

export const useFilterOptions = () => {
  // Get practice areas and cities from useFilters hook
  const { cities, practiceAreas } = useFilters();
  
  // Transform practice areas into the format needed for Dropdown component
  const serviceOptions = practiceAreas.map(area => ({
    value: area.toLowerCase().replace(/\s+/g, '-'),
    label: area
  }));
  
  // Utility function to properly capitalize city names
  const toTitleCase = (str) => {
    return str.split(' ').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ).join(' ');
  };
  
  // Create a flat list of cities for the Dropdown with deduplication and proper capitalization
  const allCities = cities.flatMap(group => group.cities);
  const areaOptions = (() => {
    const uniqueCities = [];
    const seenCities = new Set();
    
    for (const city of allCities) {
      const lowerCity = city.toLowerCase().trim();
      if (!seenCities.has(lowerCity)) {
        seenCities.add(lowerCity);
        // Properly capitalize the city name
        const formattedCity = toTitleCase(lowerCity);
        uniqueCities.push({
          value: lowerCity.replace(/\s+/g, '-'),
          label: formattedCity
        });
      }
    }
    
    return uniqueCities;
  })();
  
  // Empty budget options for free text input
  const budgetOptions = [];

  return {
    serviceOptions,
    areaOptions,
    budgetOptions
  };
}; 